// extracted by mini-css-extract-plugin
module.exports = {"single-price-selector":"SinglePriceSelector_single-price-selector__1j892"};